<template>
  <basic-dialog :visible="visible"
                :title="title"
                :width="600"
                :update-vis="updateVis"
                :handle-close="handleClose"
                :handle-closed="handleClosed"
                :handle-ok="handleOk">
    <el-form ref="dto"
             size="small"
             label-position="right"
             label-width="128px"
             :model="dto"
             :rules="rules"
             @submit.native.prevent>
      <div class="entity-dlg__block">
        <div class="entity-dlg__block-bd">
          <el-row :gutter="24">
            <el-col :span="20"
                    :offset="1">
              <el-form-item :label="$t('language.5o6u3wttjxs0')" prop="userSelectType">
                <el-radio-group v-model="dto.userSelectType" @change="changeSelectType">
                  <el-radio :label="1">{{$t('language.5o6ukqm1gimo')}}</el-radio>
                  <el-radio :label="2">{{$t('language.5o6ukq114imo')}}</el-radio>
                  <el-radio :label="3">{{$t('language.5o6ukql14imo')}}</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
            <!--重置密码-->
            <el-row v-if="PWD">
            <el-col :span="20"
                    :offset="1" style="margin-bottom:10px">
              <el-form-item :label="$t('language.5o6u3frcno70')"
                            prop="userPassWd">
                <el-input v-model.trim="dto.userPassWd"
                          :placeholder="$t('language.5o6u3frcno70')" type="password" autocomplete="off" />
              </el-form-item>
            </el-col>
            <el-col :span="20"
                    :offset="1">
              <el-form-item :label="$t('language.5o6u3frcno80')"
                            prop="confirmUserPassWd">
                <el-input v-model.trim="dto.confirmUserPassWd"
                          :placeholder="$t('language.5o6u3frc7ok0')" type="password" autocomplete="off" />
              </el-form-item>
            </el-col>
            </el-row>
            <!--重置手机号-->
            <el-row v-if="TEL">
            <el-col :span="20"
                    :offset="1" style="margin-bottom:10px">
              <el-form-item :label="$t('language.5o6u3frcno90')"
                            prop="userTel">
                <el-input v-model.trim="dto.userTel"
                          :placeholder="$t('language.5o6u3frcno90')" />
              </el-form-item>
            </el-col>
            <el-col :span="20"
                    :offset="1">
              <el-form-item :label="$t('language.5o6ukqlf4imo')"
                            prop="confirmUserTel">
                <el-input v-model.trim="dto.confirmUserTel"
                          :placeholder="$t('language.5o6akql14imo')" />
              </el-form-item>
            </el-col>
            </el-row>
            <!--重置邮箱-->
            <el-row v-if="EMAIL">
            <el-col :span="20"
                    :offset="1" style="margin-bottom:10px">
              <el-form-item :label="$t('language.5o6u3frcn1k0')"
                            prop="userEmail">
                <el-input v-model.trim="dto.userEmail"
                          :placeholder="$t('language.5o6u3frcn1k0')" />
              </el-form-item>
            </el-col>
            <el-col :span="20"
                    :offset="1">
              <el-form-item :label="$t('language.5o6akql10imo')"
                            prop="confirmUserEmail">
                <el-input v-model.trim="dto.confirmUserEmail"
                          :placeholder="$t('language.5oeakql14imo')" />
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-form>
  </basic-dialog>
</template>
<script>
// 重置密码
import EntityDialog from '@/mixins/entityDialog'
import { mapState } from 'vuex'
export default {
  mixins: [EntityDialog],
  props: {
    selectItem: {
      type: Object,
      default() {
        return {}
      }
    },
    winClose: {
      type: Function,
      default() {
        return () => { }
      }
    },
    handleSave: {
      type: Function,
      default() {
        return () => { }
      }
    },

  },
  data() {
     var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.$t('language.5o6u3frc7ok0')));
        } else if (value !== this.dto.userPassWd) {
          callback(new Error(this.$t('language.5o6u3frc8ok0')));
        } else {
          callback();
        }
      };
      var validateTel = (rule, value, callback) => {
          if (value === '') {
              callback(new Error(this.$t('language.5o6akql14imo')));
          } else if (value !== this.dto.userTel) {
              callback(new Error(this.$t('language.5oeakql14im7')));
          } else {
              callback();
          }
      };
      var validateEmail = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.$t('language.5oeakql14imo')));
        } else if (value !== this.dto.userEmail) {
          callback(new Error(this.$t('language.5oeakql14mm7')));
        } else {
          callback();
        }
      };
    return {
      rules: {
        userPassWd: [
          { required: true, message: this.$t('language.5o617mnply11'), trigger: 'blur' },
          { pattern: CNST.REG_EXP.NORMALPWD, message: this.$t('language.5oeakql17mm7') },
          { required: false, trigger: 'change'}
        ],
        confirmUserPassWd: [
          { required: true, validator: validatePass, trigger: 'blur' },
          { pattern: CNST.REG_EXP.NORMALPWD, message: this.$t('language.5oeakql17mm7') },
          { required: false, trigger: 'change'}
        ],
        userTel: [
          { required: true, message: this.$t('language.5o6u3frc9ok0'), trigger: 'blur' },
          { pattern: CNST.REG_EXP.NORMALTEL, message: this.$t('language.5o6u1gm44xk9') },
          { required: false, trigger: 'change'}
        ],
        confirmUserTel: [
          { required: true, validator: validateTel, trigger: 'blur' },
          { pattern: CNST.REG_EXP.NORMALTEL, message: this.$t('language.5o6u1gm44xk9') },
          { required: false, trigger: 'change'}
        ],
        userEmail: [
          { required: true, message: this.$t('language.5o6u3fr2nok0'), trigger: 'blur' },
          { pattern: CNST.REG_EXP.EMAIL, message: this.$t('language.5o6u3fr3nok0') },
          { required: false, trigger: 'change'}
        ],
        confirmUserEmail: [
          { required: true, validator: validateEmail, trigger: 'blur' },
          { pattern: CNST.REG_EXP.EMAIL, message: this.$t('language.5o6u3fr3nok0') },
          { max: 49, message: this.$t('language.5o6u3fr4nok0'), trigger: "blur" },
          { required: false, trigger: 'change'}
        ]
      },
      loading:false,
      options:[],
      dto:{
        userSelectType:1,
        userPassWd:null,
        confirmUserPassWd:null,
        userTel:null,
        confirmUserTel:null,
        userEmail:null,
        confirmUserEmail:null,
      },
      PWD:true,
      TEL:false,
      EMAIL:false,
      placeholder:""
    }
  },
  computed: {
      ...mapState('app', ['tenementCode'])
  },
  created(){
  },
  //单选操作类型触发事件
  methods: {
    changeSelectType(){
      if(this.dto.userSelectType == '1'){
        this.PWD=true
        this.TEL=false
        this.EMAIL=false
        this.$refs['dto'].resetFields()
        this.dto.userSelectType=1

      }else if(this.dto.userSelectType == '2'){
        this.PWD=false
        this.TEL=true
        this.EMAIL=false
        this.$refs['dto'].resetFields()
        this.dto.userSelectType=2

      }else if(this.dto.userSelectType == '3'){
        this.PWD=false
        this.TEL=false
        this.EMAIL=true
        this.$refs['dto'].resetFields()
        this.dto.userSelectType=3
      }
    },
    // 确定按钮
    handleOk(ev) {
      let selectType=this.dto.userSelectType
      let psd=this.dto.userPassWd
      let confirmPsd=this.dto.confirmUserPassWd
      if(selectType === 1){
        const encrypt = new window.JSEncrypt();
        encrypt.setPublicKey(CNST.PUBLICKEY);
        psd=encrypt.encrypt(psd);
        confirmPsd=encrypt.encrypt(confirmPsd)
        // psd=this.$md5(this.dto.userPassWd).toUpperCase()
        // confirmPsd=this.$md5(this.dto.confirmUserPassWd).toUpperCase()
      }
      if (!this.$refs.dto) {
                return
            }
            this.$refs.dto.validate(valid => {
                if (!valid) {
                    return
                }
                let params = {
                  userSelectType:this.dto.userSelectType,
                  userPassWd:psd,
                  confirmUserPassWd:confirmPsd,
                  userTel:this.dto.userTel,
                  confirmUserTel:this.dto.confirmUserTel,
                  userEmail:this.dto.userEmail,
                  confirmUserEmail:this.dto.confirmUserEmail
                }
                this.handleSave({ params, type: this.action})
                this.$refs['dto'].resetFields()
                this.PWD=true
                this.TEL=false
                this.EMAIL=false
            })
    },
    // 取消按钮
    handleClose(ev) {
      console.log('handleClose:', ev)
      this.updateState('entity')
      if (this.$refs.dto) {
        this.$nextTick(() => {
          this.$refs.dto.clearValidate()
        })
      }
      this.winClose(ev)
      this.$refs['dto'].resetFields()
      this.PWD=true
      this.TEL=false
      this.EMAIL=false
    },
  }
}
</script>

<style lang="scss" scoped>
/deep/ .cascader input::placeholder{
  color: #606266;
}
</style>

